import ReactPDF, { View } from '@react-pdf/renderer'
import React from 'react'

import { ConselhoClasseImpressao } from './model'
import { PrintSign } from './PrintSign'

export interface PrintBodyProps {
  children: React.ReactNode
  styles?: ReactPDF.Style
  showSign?: boolean
  nomeProfissional?: string
  cboProfissional?: string
  conselhoClasse?: ConselhoClasseImpressao
}

export const PrintBody = (props: PrintBodyProps) => {
  const { children, styles, showSign, ...rest } = props

  return (
    <View style={styles}>
      {children}
      {showSign && <PrintSign {...rest} />}
    </View>
  )
}
